import { WrapperWidget } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { useTranslate } from '@tolgee/react';

export function EmptyWidget() {
  const { t } = useTranslate();

  return (
    <WrapperWidget>
      <EmptyState
        title={t('emptywidget_title') || 'Noch keine Inhalte'}
        description={
          t('emptywidget_description') ||
          'Für diesen Bereich sind aktuell keine Daten hinterlegt. Sobald Inhalte verfügbar sind, erscheinen sie hier.'
        }
      />
    </WrapperWidget>
  );
}
